<template>
  <ic-dialog
    ref="dialog"
    class="ic-account-modal"
    :class="{ 'ic-dialog--no-close': !allowClose }"
    :closed-by="allowClose ? 'any' : 'none'"
    @close="handleClose"
  >
    <slot />
  </ic-dialog>
</template>

<script>
import IcDialog from '@/components/ic-dialog';

export default {
  name: 'ic-account-modal',
  components: { IcDialog },
  props: {
    allowClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    handleClose() {
      if (this.allowClose) {
        this.$emit('ic-account-modal-close');
      }
    }
  }
};
</script>
